import { Component, OnInit } from '@angular/core';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-transit',
  templateUrl: './transit.component.html',
  styleUrls: ['./transit.component.sass']
})
export class TransitComponent implements OnInit {
  constructor(private loadingScreenService: LoadingScreenService, private global: GlobalService, private router: Router,private route: ActivatedRoute){}
  ngOnInit(): void {
    this.transitToken();
  }

  transitToken(){
    let token=localStorage.getItem("tokenExternal");
    this.loadingScreenService.startLoading();
    this.route.queryParams.subscribe(params => {
      this.loadingScreenService.stopLoading();
      if (params && params.url) {
        let path=String(params.url);
        path=path.substring(0,((path).replace("//","**")).indexOf("/"));
        let urlPath=(String(params.url)).replace(path,"");
        let redirectUrl= path+"/"+params.module+"?url="+urlPath+"&token="+token;
        location.href=redirectUrl;
      }
    });
  }
}
